import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {Principal,StateStorageService} from 'src/app/core';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {OtsDataSharingModal} from 'src/app/shared/model/ots-data-sharing.model';
import {IRuleMySuffix} from 'src/app/shared/model/rule-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {SubRuleMySuffixService} from '../sub-rule-my-suffix';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { TdisConstants } from 'src/app/shared/constants/tdis-constants';

declare let $:any;
@Component({
    selector: 'jhi-rule-my-suffix-detail',
    templateUrl: './rule-my-suffix-detail.component.html'
})
export class RuleMySuffixDetailComponent implements OnInit {

    readonly RoleUtil = RoleUtil;
    readonly TdisConstants = TdisConstants;

    @ViewChild('confirmDelete') confirmDelete: ModalDirective;
    @ViewChild('ruleDraftRelationModal') ruleDraftRelationModal: ModalDirective;
    @ViewChild('viewMoreModal') viewMoreModal: ModalDirective;

    rule: IRuleMySuffix;
    scopeId: number;
    policyDeductibleType : any;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    openRequest : boolean = false; 
    navigableScopeID: any;
    navigableRuleID: any;
    subRules:any;
    subRuleToUpdateStatus :any;
    // isFromAutomateOts: boolean = false;
    editPermission:boolean = false;

    


/*
Do not remove language service, if you remove this its object is not loaded then translation won't work
*/
    constructor(private activatedRoute: ActivatedRoute, 
        private principal: Principal,
        private router:Router,
        private languageChangeService:LanguageChangeService,
        private subRuleService:SubRuleMySuffixService,
        private jhiAlertService: JhiAlertService,
        private stateStorageService:StateStorageService
       ) { 
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
       }

    summaryDetailsUrl: string = '';
    otsKeyword: string = '';
    isOts: boolean = false;
    randomOtsId=null;

    ngOnInit() {

        const CURRENT_URL: string = this.router.url;
        let current_url_split: string[] = CURRENT_URL.split('/');
        this.isOts = current_url_split.includes('ots');
        const isSummaryDetailsUrl: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);

        if(this.isOts && isSummaryDetailsUrl) {
            this.summaryDetailsUrl = JSON.parse(isSummaryDetailsUrl);
            this.otsKeyword = 'ots';
            // console.warn(this.isOts, this.summaryDetailsUrl);
        }
        
        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];
        
        if(this.randomOtsId!=null && this.stateStorageService.contains(this.randomOtsId)) {
            this.summaryDetailsUrl=this.stateStorageService.getCurrentSummaryPageUrl(this.randomOtsId);
            this.isOts=true;
            this.otsKeyword = 'ots';
        }


        this.principal.setTitle("Rules");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.scopeId = this.activatedRoute.snapshot.params['scopeId'];
        this.checkAccountingPermission();
        this.checkPremiumCalculationPermission();
        
        // this.isFromAutomateOts = this.activatedRoute.snapshot.params['ots']!=undefined;

        this.activatedRoute.data.subscribe(( res ) => {   
            let payload = res.rule;

            if(res.pageTitle =="OpenRules"){
                // this.editPermission = JSON.parse(localStorage.getItem("allowBrokerForManualRequests"))
                // console.log(this.editPermission)
                this.openRequest = true;
                
            }
            // console.warn(payload.body.loadingSubTypes);
            
            payload.body.loadingSubTypes = this.groupedLoadingType(payload.body.loadingSubTypes);
            this.rule = payload.body;
            // console.warn(this.rule.loadingSubTypes);
        });

        if(this.rule.deductableRates.length != 0) {
            let obj : any = {};
            obj = this.rule.deductableRates[0];
            this.policyDeductibleType = this.rule.scopeDeductableType;
        }

        
        this.rule.deductableRates;
        if(this.rule.type == 'INTERNATIONAL' && this.rule.meansOfConveyance !== 'ROAD'){
            this.getSubRule(this.rule.id);
        }
        
    }

    viewHistoryRule( subRule) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Sub Rule History';
        this.historyType = "SUB_RULE_AUDIT";
        this.historyId = subRule.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');

    }

    previousState() {
        
        if(this.router.url.includes('open-policy')) {
            console.warn('hello');
            this.router.navigate(['scope-my-suffix/open-policy-scope-my-suffix', this.scopeId, 'view' ])
        }else if(this.scopeId) {
            console.warn('hello');
            this.router.navigateByUrl('scope-my-suffix/'+this.scopeId+'/view')
        } else {
            console.warn('hello');
            window.history.back();
        }
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewHistory(ruleObj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Rule History';
        this.historyType = "RULE_AUDIT";
        this.historyId = ruleObj.id;
    }

    viewFutureHistory(ruleObj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Rule Future Records';
        this.historyType = "RULE_AUDIT";
        this.historyId = ruleObj.id;
    }
    checkRelationWithDraftRequest(inRelation,ruleID){
        this.navigableScopeID=this.scopeId;
        this.navigableRuleID= ruleID
        if(inRelation){
                this.ruleDraftRelationModal.show()
        } else if(this.otsKeyword && this.summaryDetailsUrl) {
            this.router.navigate([ '/rule-my-suffix'+"/"+ruleID+"/"+this.scopeId+"/"+'ots'+"/"+'edit' ],{queryParams: {ranOtsId: this.randomOtsId}});
        } else{
           
                this.router.navigate(['/rule-my-suffix',ruleID, this.scopeId, 'edit'])
              
        }

    }
    hideRuleDraftRelationModal(){
        this.ruleDraftRelationModal.hide()
    }
    navigateRuleSuffix(){
        this.router.navigate(['/rule-my-suffix',this.navigableRuleID, this.navigableScopeID, 'edit'])
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    getSubRule(ruleId:number){
        this.subRules = [];
        this.subRuleService.get("api/sub-rule/rule-id/"+ruleId).subscribe(res=>{
            this.subRules = res.body;
        },err=>{});
    }

    getSubRuleById(id:number){
        this.subRuleService.get("api/sub-rule/"+id).subscribe(res=>{
            console.log(res.body);
            
        },err=>{});
    }
    activateInactivateSubRule(subRule){
        this.subRuleToUpdateStatus = subRule;
        this.confirmDeleteShow();
    }

    confirmDeleteShow(){
        this.confirmDelete.show();
    }

    confirmDeleteHide(){
        this.subRuleToUpdateStatus  = null;
        this.confirmDelete.hide();
    }
    updateActiveStatusOfSubRUle(){
        ;
        this.subRuleService.delete(this.subRuleToUpdateStatus.id).subscribe(res=>{
            this.confirmDeleteHide();
            this.getSubRule(this.rule.id);

        },err=>this.onError(err.message));

    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    isAcoountingDisable:boolean;
    isPremiumCalculationDisable:boolean;
    checkAccountingPermission(){
        this.principal.checkAccountingAccessForUser().then(res =>{
            if(res){
                console.log("checkAccountingAccessForUser if" , res);
                this.isAcoountingDisable = false;
            }else{
                console.log("checkAccountingAccessForUser else" , res);

                this.isAcoountingDisable =  true;
            }
        });
    }

    checkPremiumCalculationPermission(){
        this.principal.checkPremiumCalculationAccessForUser().then(res =>{
            if(res){
                console.log("checkPremiumCalculationPermission if" , res);
                this.isPremiumCalculationDisable= false;
            }else{
                console.log("checkPremiumCalculationPermission else" , res);
                this.isPremiumCalculationDisable= true;
            }
        });
    }

    dataText="";
    viewMoreData: any[]=[];
    showViewMoreModal(data,dataText) {
        
        this.viewMoreData = data;
        this.viewMoreModal.show();
        this.dataText=dataText;

    }

    hideViewMoreModal() {
        this.viewMoreModal.hide();
        this.viewMoreData=[];
        this.dataText=""
    }

    groupedLoadingData: any = [];
    groupedLoadingType(loadingSubTypes: any[]) {
        this.groupedLoadingData = [];
        // creating hash map
        let map = new Map<any,any[]>();
        
        loadingSubTypes.forEach(subType => {
            if(map.has(subType.loadingTypeName)){
                let data = map.get(subType.loadingTypeName);
                data.push(subType);
                map.set(subType.loadingTypeName,data);
            }else{
                map.set(subType.loadingTypeName,[subType]);
            }
        })

        let temp = [];
        Array.from(map.values()).forEach(subType => {
            subType.forEach(type=>{
                temp.push(type);
            })
        })

        return temp;

    }

    addSubRule(){
        this.router.navigate(['/sub-rule-my-suffix/new/', this.rule.id , this.rule.policyMarketType]);
    }

    dataSharingModal:OtsDataSharingModal = new OtsDataSharingModal();
    
    addOtsSubRule(isEdit){
        this.dataSharingModal.policyScopeType = this.rule.policyMarketType;
        this.dataSharingModal.otsScopeId=this.scopeId;
        this.dataSharingModal.otsRuleId=this.rule.id;
        this.dataSharingModal.otsSubRules=[];
        this.dataSharingModal.otsSubRuleIds=[];
        this.dataSharingModal.isEdit = isEdit;
        this.dataSharingModal.isOts = true;
        
        // this.router.navigate(['sub-rule-my-suffix/new/ots/', null,'add'],{queryParams:{sharedData:JSON.stringify(this.dataSharingModal)}}),
        this.router.navigate(['/sub-rule-my-suffix/ots/', this.scopeId, this.rule.id , this.rule.policyMarketType],{queryParams:{ranOtsId:this.randomOtsId}});
    }

       
}
